// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  ga: 'G-XXXXXXXXXX', // Google Analytics Code
  adClient: 'ca-pub-1048895553844454', // Google Adsense AdClient
  adSlot: 4198068219, // Google Adsense AdSlot
  firebase: {
    apiKey: "AIzaSyDU8jPDwvZsB9Pxskx9Bk2iQM4_hj1ahbY",
    databaseURL: "https://pdfunitconverter-default-rtdb.asia-southeast1.firebasedatabase.app",
  authDomain: "pdfunitconverter.firebaseapp.com",
  projectId: "pdfunitconverter",
  storageBucket: "pdfunitconverter.firebasestorage.app",
  messagingSenderId: "491919804901",
  appId: "1:491919804901:web:b4f2b99f9309140b6e470c",
  measurementId: "G-G2RSF942FQ"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
